/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupslisted1Inputs */

const en_groupslisted1 = /** @type {(inputs: Groupslisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show on your page`)
};

const de_groupslisted1 = /** @type {(inputs: Groupslisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf deiner Seite zeigen`)
};

/**
* | output |
* | --- |
* | "Show on your page" |
*
* @param {Groupslisted1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupslisted1 = /** @type {((inputs?: Groupslisted1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupslisted1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupslisted1(inputs)
	return de_groupslisted1(inputs)
});
export { groupslisted1 as "groupsListed" }